var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTop3 = function SvgTop3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#top3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F1F4",
    d: "m20.239.7 1.625 5.055L34.49 27.953l5-2.704L28.385 2.23l-2.24-4.867L20.24.701Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B00",
    d: "m13.63-.99 5.068-2.74L33.84 25.224l-5.069 2.74L13.63-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9E7EC",
    d: "m41.644-.234-5-2.703-14.646 28.003 5 2.703L39.453 5.905l2.192-6.139Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F00000",
    d: "m42.587-3.445 5.068 2.74L32.65 27.986l-5.069-2.74 15.006-28.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19B5E",
    d: "m30.687 13.46-.822 15.337.822 15c8.23 0 14.924-6.805 14.924-15.172-.008-8.36-6.701-15.164-14.924-15.164Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F19B5E",
    d: "M15.764 28.625c0 8.367 6.693 15.172 14.923 15.172V13.46c-8.23 0-14.923 6.805-14.923 15.164Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8348",
    d: "m30.687 15.805-.822 12.992.822 12.656c6.955 0 12.618-5.75 12.618-12.828-.008-7.07-5.663-12.82-12.618-12.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8348",
    d: "M18.07 28.625c0 7.07 5.655 12.828 12.617 12.828V15.805c-6.962 0-12.617 5.75-12.617 12.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.946 34.023 1.33-1.82c.845.844 1.89 1.492 3.18 1.492 1.445 0 2.43-.726 2.43-2.023 0-1.43-.83-2.313-3.935-2.313v-2.078c2.62 0 3.473-.922 3.473-2.218 0-1.141-.692-1.805-1.906-1.82-1.022.023-1.852.507-2.697 1.296l-1.445-1.766c1.238-1.101 2.605-1.78 4.28-1.78 2.76 0 4.627 1.374 4.627 3.859 0 1.57-.869 2.703-2.39 3.312v.102c1.621.453 2.85 1.664 2.85 3.57 0 2.664-2.297 4.219-5.017 4.219-2.252-.008-3.773-.875-4.78-2.032Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "top3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v44H0z"
  })))));
};
export default SvgTop3;